import React from 'react'
import { ProgramProfile } from './form-program-profile';
import { DateLocation } from './form-date-location';
import { FormMilestone } from './form-milestone';
import { FormJourney } from './form-journey';
import { FormBeneficiaries } from './form-beneficiaries';
import { FormStory } from './form-story';
import { SidebarPartner } from './sidebar-partner';
import {
  FormDashboardLabel as Label,
  ImagePickerSidebar,
  SelectCheckbox,
  TagAdder,
  Button,
  ButtonOutline,
} from '../../../components';
import { SidebarOfficer } from './sidebar-officer';
import { FileUploader } from './file-uploader';
import { useHistory } from 'react-router-dom';
import { FormTestimoni } from './form-testimoni';
import { FormRelated } from './form-related';
import { RejectionPopup } from './rejection-popup';

const FormMobile = () => {
  const isMobile = true
  const history = useHistory()
  const [rejectionPopedUp, setRejectionPopedUp] = React.useState(false);
  const [form, setForm] = React.useState({
    date_visibility: 'public',
    milestone_visibility: 'public',
    journey_visibility: 'public',
    beneficiaries_visibility: 'public',
    impact_visibility: 'public',
  })

  const updateForm = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    })
  }

  return (
    <form>
      <div className="mobile-fullwidth">
        <div className="p-6 mb-8 text-center" style={{background: '#f5f5f5'}}>
          <p className="text-sm text-gray-444">Status: <strong>Rejected</strong></p>
          <p className="link mb-3" onClick={() => setRejectionPopedUp(true)}>Apa yang harus diperbaiki?</p>
          {
            rejectionPopedUp &&
            <RejectionPopup onClose={setRejectionPopedUp}/>
          }
          <p className="text-sm text-gray-444">Program Status: <span style={{color: '#FF5448'}}>Ongoing</span></p>
        </div>
      </div>

      <ProgramProfile form={form} updateForm={updateForm} isMobile={isMobile}/>

      <div className="mb-8">
        <ImagePickerSidebar label="Thumbnail Image"/>
      </div>

      <div className="mb-8">
        <SidebarPartner />
      </div>

      <div className="mb-8">
        <SidebarOfficer />
      </div>

      <div className="mb-8">
        <Label>Suitable For</Label>
        <SelectCheckbox className="text-sm" placeholder="Choose"/>
      </div>

      <div className="mb-8">
        <Label>Upload final report</Label>
        <FileUploader />
      </div>

      <div className="mb-8">
        <Label>Tag</Label>
        <TagAdder />
      </div>

      <hr className="my-8"/>

      <DateLocation form={form} updateForm={updateForm} isMobile={isMobile}/>

      <hr className="my-8"/>

      <FormMilestone form={form} updateForm={updateForm} isMobile={isMobile}/>

      <hr className="my-8"/>

      <FormJourney form={form} updateForm={updateForm} isMobile={isMobile}/>

      <hr className="my-8"/>

      <FormBeneficiaries form={form} updateForm={updateForm} isMobile={isMobile}/>

      <hr className="my-8"/>

      <FormStory />

      <hr className="my-8"/>

      <FormTestimoni />

      <hr className="my-8"/>

      <FormRelated />

      <div className="mb-10">
        <Button thin className="mb-3" onClick={() => history.push('/dashboard/programs')}>Submit</Button>
        <ButtonOutline
          transparent
          outlineColor="primary"
          className="text-primary uppercase font-accent"
          onClick={() => history.push('/dashboard/programs')}
        >
          Save to Draft
        </ButtonOutline>
      </div>
    </form>
  )
}

export { FormMobile }